import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import logoImage from "./assetes/images/logojuristbot.svg";
import "./Navbar.css";

/* ---------- Menu data (edit here once – applies to every page) ---------- */
export const legalTools = [
  { label: "AI Legal Research", to: "/ai-legal-research-software-chatbot-assistant-juristbot-ai" },
  { label: "Scenario Solver", to: "/ai-legal-scenario-solver-and-legal-case-analysis-juristbot-ai" },
  { label: "AI Legal Drafting", to: "/ai-legal-drafting-software-chatbot-juristbot-ai" },
  { label: "AI Cross Examination", to: "/ai-legal-cross-examination-chabot-juristbot-ai" },
  { label: "Judgment Finder", to: "/ai-legal-judgment-finder-for-indian-case-law-juristbot-ai" },
];

export const navLinks = [
  { label: "Pricing", to: "/#pricing" },
  { label: "DPDP Shield", to: "/dpdpshield" },
  { label: "Legal Courses", to: "/course" },
  { label: "Listing", to: "/list-lawyers" },
  { label: "Contact us", to: "/#contact" },
];

const isDesktop = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(min-width: 1200px)").matches;

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);   // mobile panel
  const [isToolsOpen, setIsToolsOpen] = useState(false); // Legal Tools dropdown
  const navRef = useRef(null);

  const closeAll = () => {
    setIsMenuOpen(false);
    setIsToolsOpen(false);
  };

  // Smooth-scroll to #pricing / #contact (works from any page -> "/")
  useEffect(() => {
    if (!location.hash) return;
    const timer = setTimeout(() => {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 500);
    return () => clearTimeout(timer);
  }, [location]);

  // Close everything when the route changes
  useEffect(() => {
    setIsMenuOpen(false);
    setIsToolsOpen(false);
  }, [location.pathname, location.hash]);

  // Close on outside click + ESC
  useEffect(() => {
    if (!isMenuOpen && !isToolsOpen) return;

    const handleOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setIsMenuOpen(false);
        setIsToolsOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsMenuOpen(false);
        setIsToolsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, [isMenuOpen, isToolsOpen]);

  const isActive = (to) => {
    const [path, hash] = to.split("#");
    if (hash) return location.pathname === "/" && location.hash === `#${hash}`;
    return location.pathname === path;
  };

  const toolsActive = legalTools.some((t) => location.pathname === t.to);

  return (
    <nav
      ref={navRef}
      className="navbar navbar-expand-xl navbar-dark bg-dark nav-bar-cls"
    >
      <div className="container-fluid jb-nav-inner">
        {/* Logo */}
        <Link to="/" className="jb-logo-wrap" onClick={closeAll}>
          <img src={logoImage} alt="JuristBot AI logo" className="landinglogo" />
        </Link>

        {/* Toggler: bars <-> X */}
        <button
          type="button"
          className="navbar-toggler navbar-toggler_2"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-controls="jbMainNav"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={isMenuOpen ? faXmark : faBars} />
        </button>

        {/* Menu panel */}
        <div
          id="jbMainNav"
          className={`collapse navbar-collapse jb-menu-panel ${isMenuOpen ? "show" : ""}`}
        >
          <ul className="navbar-nav jb-nav-list">
            {/* Legal Tools dropdown */}
            <li
              className={`nav-item nav-cls jb-dropdown ${isToolsOpen ? "open" : ""}`}
              onMouseEnter={() => isDesktop() && setIsToolsOpen(true)}
              onMouseLeave={() => isDesktop() && setIsToolsOpen(false)}
            >
              <button
                type="button"
                className={`nav-link jb-dropdown-toggle ${toolsActive ? "active" : ""}`}
                aria-haspopup="true"
                aria-expanded={isToolsOpen}
                onClick={() =>
                  setIsToolsOpen((prev) => (isDesktop() ? true : !prev))
                }
              >
                Legal Features
                <FontAwesomeIcon icon={faChevronDown} className="jb-dropdown-caret" />
              </button>

              <ul className="jb-dropdown-menu" role="menu">
                {legalTools.map((tool) => (
                  <li key={tool.to} role="none">
                    <Link
                      role="menuitem"
                      to={tool.to}
                      className={`jb-dropdown-item ${
                        location.pathname === tool.to ? "active" : ""
                      }`}
                      onClick={closeAll}
                    >
                      {tool.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            {/* Normal links */}
            {navLinks.map((link) => (
              <li key={link.label} className="nav-item nav-cls">
                <Link
                  to={link.to}
                  className={`nav-link ${isActive(link.to) ? "active" : ""}`}
                  onClick={closeAll}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="massnav">
            <Link to="/login" onClick={closeAll}>
              <button type="button" className="juristbotAIbtn">
                Login
              </button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;